const product_links = document.getElementsByClassName('full-unstyled-link');

for (let i = 0; i < product_links.length; i++) {
  const product_link = product_links[i];
  const hover_effect = product_link.closest('.card-wrapper').querySelector('.hover-massage-effect');

  if (hover_effect) {
    product_link.addEventListener('mouseenter', () => {
      // 全ての関連クラスを削除してから、フェードインクラスを追加
      hover_effect.classList.remove('hover-massage-disappearance');
      hover_effect.classList.add('hover-massage-appearance');
    });

    product_link.addEventListener('mouseleave', () => {
      // フェードアウトクラスを追加
      hover_effect.classList.remove('hover-massage-appearance');
      hover_effect.classList.add('hover-massage-disappearance');
    });

    // アニメーション完了時にクラスを削除
    hover_effect.addEventListener('animationend', (event) => {
      // フェードアウトアニメーションが終わった時のみクラスを削除
      if (event.animationName === 'product_hover_effect' && hover_effect.classList.contains('hover-massage-disappearance')) {
        hover_effect.classList.remove('hover-massage-disappearance');
      }
    });
  }
}